module.exports = __webpack_public_path__ + "static/media/8.2cf253ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobileOmBoarding/8.png
// module id = 937
// module chunks = 21